<template>
  <div class="linkbucket">
    <div class="lbleft">
      <a
        href="#"
        @click.prevent="toggleFootnotes">{{ showHideFootnotesLabel }}</a>
        <!-- <a :href="printerFriendlyUrl">Printer friendly</a> -->
    </div>
    <div class="lbright">
      <a
        :href="dataGuideUrl"
        @click="dataGuideClicked"
      >Data Guide</a>
      <router-link
        :to="viewAllLocationsUrl"
        @click.native="viewAllLocationsClicked">
        View all locations
        <img
          src="./assets/usa.png"
          width="29"
          height="20"
          alt="Map icon" >
      </router-link>
    </div>
  </div>
</template>

<script>
/* global triggerOmnitureInteractions */
import { mapState } from 'vuex';
import _ from 'lodash';
import helper from '../../helper';

export default {
  computed: {
    ...mapState({
      footnotes: state => state.footnotes,
      showFootnotes: state => state.SP.flags.showFootnotes,
      GSGo: state => state.SP.GSGo,
      initialPageLoad: state => state.flags.initialPageLoad,
      indicators: state => state.SP.indicators,
    }),
    showHideFootnotesLabel() {
      return this.showFootnotes ? 'Hide footnotes' : 'Show footnotes';
    },
    dataGuideUrl() {
      const row = _(this.footnotes).find({ type: 'RelatedLinks', ft: 'Data Guide' });
      return row ? helper.convertRelativeUrlToWCMSUrl(row.url) : '';
    },
    viewAllLocationsUrl() {
      return `/LP?CategoryId=${this.GSGo.categoryId}`;
    },
    printerFriendlyUrl() {
      const { query } = this.$route;
      query.showMode = 'export';
      const qs = _(query).map((val, key) => `${key}=${val}`).value().join('&');
      return `${this.$route.path}?${qs}`;
    },
    indicatorIdsForInteraction() {
      return _(this.indicators).map('id').value().join('-');
    },
  },
  methods: {
    toggleFootnotes() {
      triggerOmnitureInteractions(`${process.env.InteractionIdentifier}-LB ${this.showFootnotes ? 'HF' : 'SF'},${this.GSGo.locationId},${this.GSGo.categoryId},${this.indicatorIdsForInteraction}`);
      this.$store.commit('SP/setShowFootnotes', !this.showFootnotes);
      this.$store.getters['SP/setBrowserUrlBarToReflectCurrentSPState'](this.$router);
    },
    dataGuideClicked() {
      triggerOmnitureInteractions(`${process.env.InteractionIdentifier}-LB DG,${this.GSGo.locationId},${this.GSGo.categoryId},${this.indicatorIdsForInteraction}`);
    },
    viewAllLocationsClicked() {
      // the @click.native modifier is needed when using a router-to instead of a normal <a> link
      // for this event handler to fire per https://github.com/vuejs/vue-router/issues/800#issuecomment-254623582

      // set initialPageLoad to true so LP will use the query string parm
      this.$store.commit('setInitialPageLoad', true);
      triggerOmnitureInteractions(`${process.env.InteractionIdentifier}-LB VA,${this.GSGo.locationId},${this.GSGo.categoryId},${this.indicatorIdsForInteraction}`);
    },
  },
};
</script>


<style scoped>
  .linkbucket {
    display: table;
    background-color: rgb(242, 242, 242);
    /* margin: 8px; */
    padding: 8px;
    min-width: 300px;
  }

  .linkbucket a {
    display: block;
  }

  .lbleft {
    display: table-cell;
    width: 50%;
  }

  .lbright {
    display: table-cell;
    width: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/SP/SPLinkBucket.vue